/**
 * Broker Settings Types
 * 交易商全局设置类型定义
 */

/**
 * 交易商全局设置
 */
export interface BrokerSettings {
  brokerUid: string;             // 交易商UID（8位数字）
  
  // 费率设置
  fees: {
    taker: number;               // Taker费率 (0.0005 = 0.05%)
    maker: number;               // Maker费率 (0.0002 = 0.02%)
    deposit: number;             // 充值费率 (0.03 = 3%)
  };
  
  // 交易商回馈
  rebate: {
    enabled: boolean;            // 启用交易商回馈
    rate: number;                // 回馈比例 (0.02 = 2%)
    
    // 回馈限制
    restrictions: {
      timeWindowHours: number;      // 时间窗口（小时）
      maxAmountPerWindow: number;   // 时间窗口内最大回馈金额（USDT）
    };
  };
  
  // 对冲设置
  hedge: {
    enabled: boolean;            // 启用对冲
    autoHedge: boolean;          // 自动对冲
    threshold: number;           // 对冲阈值 (USDT)
    ratio: number;               // 对冲比例 (0-100%)
  };
  
  // 元数据
  updatedAt: number;             // 最后更新时间
  updatedBy: string;             // 更新人（UID）
}

/**
 * 默认交易商设置
 */
export const DEFAULT_BROKER_SETTINGS: Omit<BrokerSettings, 'brokerUid' | 'updatedAt' | 'updatedBy'> = {
  fees: {
    taker: 0.0005,    // 0.05%
    maker: 0.0002,    // 0.02%
    deposit: 0.03,    // 3%
  },
  rebate: {
    enabled: true,
    rate: 0.01,       // 1%
    restrictions: {
      timeWindowHours: 24,        // 24小时
      maxAmountPerWindow: 100,    // 100 USDT
    },
  },
  hedge: {
    enabled: true,
    autoHedge: true,   // 自动对冲：开启
    threshold: 0,      // 对冲阈值：0 USDT
    ratio: 100,        // 对冲比例：100%
  },
};

